import { PageHeader } from "@/components/PageHeader";
import { AppQuickSearchTab } from "./AppQuickSearchTab";

export function UtilsPage() {
  return (
    <div className="px-4 py-0">
      <PageHeader
        title="Quick App Search"
        subtitle="Look up any App Store or Google Play app and inspect what the platform sees for it."
      />

      <AppQuickSearchTab />
    </div>
  );
}
